import Image from "next/image";
import Link from "next/link";
import styles from "./index.module.css";
import { sizes } from "@/lib/utils";
export const RecentlyViewedCard = ({
	href,
	name,
	image,
}: {
	href: string;
	name: string | undefined;
	image: string | undefined;
}) => {
	return (
		<Link title={name} href={href} className={styles.card}>
			{image && <Image sizes={sizes(100, 30)} fill alt={`${name}`} src={image} />}
		</Link>
	);
};
